"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focus = exports.getFocusableChildren = void 0;
var utils_1 = require("../../utils/utils");
var Constants_1 = require("../Constants");
/** Get all the children of this element that are focusable. */
function getFocusableChildren(inElement) {
    return inElement ? Array.from(inElement.querySelectorAll(Constants_1.focusableSelector)) : [];
}
exports.getFocusableChildren = getFocusableChildren;
/** Transfer the focus to an element that isn't traditionally focusable. This is for accessibility purposes if you need to move the focus somewhere but don't exactly have a precise target for it. */
exports.focus = utils_1.makeSsrSafe(function (element, preventScroll) {
    if (preventScroll === void 0) { preventScroll = true; }
    if (!element) {
        return;
    }
    var selectable = element.matches(Constants_1.focusableSelector);
    var tabIndex;
    if (!selectable) {
        tabIndex = element.getAttribute("tabindex");
        element.tabIndex = 0;
    }
    var scrollX = window.scrollX, scrollY = window.scrollY;
    element.focus({
        preventScroll: preventScroll,
    });
    if (preventScroll && (window.scrollY !== scrollY || window.scrollX !== scrollX)) {
        window.scrollTo(scrollX, scrollY);
    }
    if (tabIndex) {
        element.setAttribute("tabindex", tabIndex);
    }
    else {
        element.removeAttribute("tabindex");
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Functions/Focus.js
// module id = 1646
// module chunks = 8